import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import React from "react";
import MenuApp from "./MenuApp";
import { IReduxState } from "../../../store";



const Liste = () => {

  const { filteredUtilisateurs, typeUtilisateurs, personnes } = useSelector((state: IReduxState) => state.utilisateurAppGestionInterne);



  return (
    <>
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {filteredUtilisateurs.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp
                        user={item}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemText
                        primary={`
                        ${personnes.find(p => p.idPersonne === item.idPersonne)?.nom}
                        ${personnes.find(p => p.idPersonne === item.idPersonne)?.prenom}
                        `}
                        secondary={
                          <Box style={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="caption">
                              {`${typeUtilisateurs.find(t => t.idTypeUtilisateur === item.idTypeUtilisateur)?.libTypeUtilisateur}`}
                            </Typography>
                            <Typography variant="caption">
                              {`${item.email}`}
                            </Typography>
                            <Typography variant="caption">
                              {`${item.passwordInitial}`}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
    </>
  );
};
export default Liste;
